<template>
    <div>
        <div class="our-services-offers-switch">
            <label
                class="selection-item"
            >
                <span>
                    {{ $t('our-services.professional') }}
                </span>
                <div class="switch">
                    <input
                        type="checkbox"
                        @change="priceIndividual = !priceIndividual"
                        :checked="priceIndividual"
                    >
                    <div class="slider" />
                </div>
                <span>
                    {{ $t('our-services.individual') }}
                </span>
            </label>
        </div>
        <div class="our-services-offers-container">
            <div
                class="offer-card-wrapper"
                v-for="(offer, offerIndex) in offers"
                :key="offerIndex"
            >
                <div class="offer-card">
                    <div class="offer-header-container">
                        <div class="premium-banner-container">
                            <div class="premium-banner" v-if="offer.is_premium">
                                <div class="banner-title">
                                    {{ $t('our-services.premium-club') }}
                                </div>
                            </div>
                        </div>
                        <h3 class="offer-header" v-html="offer.name" />
                        <a
                            v-if="isMobile"
                            :class="[
                                'collapse-button',
                                isVisible(offerIndex) ? 'rotate-open' : 'rotate-close',
                            ]"
                            @click="collapsedOffers[offerIndex] = !collapsedOffers[offerIndex]"
                        >
                            <i class="material-icons arrow-down-icon">keyboard_arrow_down</i>
                        </a>
                    </div>
                    <h3 class="offer-pricing" v-html="priceIndividual ? offer.pricing_individual : offer.pricing" />
                    <div
                        :class="[
                            isVisible(offerIndex) || !isMobile ? 'collapse-open' : 'collapse-close', 'collapsible-details',
                            offerIndex == 'free' ? 'free' : '',
                        ]"
                    >
                        <table class="offer-details-container">
                            <tr v-for="(detail, detailIndex) in offer.details" :key="detailIndex">
                                <td><img class="plane-icon" src="/imgs/icons/green-plane.webp" alt=""></td>
                                <td v-html="detail" />
                            </tr>
                        </table>
                    </div>
                    <a
                        href="/registration/fill-profile"
                        class="md-button md-raised md-primary md-theme-default offer-button"
                    >
                        <span class="md-ripple md-disabled">{{ $t('our-services.register') }}</span>
                    </a>
                </div>
                <div v-if="!isMobile">
                    <div v-for="(footnote, footnoteIndex) in offer.footnotes" :key="footnoteIndex">
                        <p class="card-footnote" v-html="footnote" />
                    </div>
                </div>
            </div>
            <div v-if="isMobile">
                <div v-for="(footnote, footnoteIndex) in allFootnotes" :key="footnoteIndex">
                    <p class="card-footnote" v-html="footnote" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        offers: Object,
        allFootnotes: Array,
    },
    data() {
        return {
            collapsedOffers: {},
            priceIndividual: false
        };
    },
    computed: {
        isMobile() {
            return window.innerWidth <= 1024;
        },
    },
    mounted() {
        Object.entries(this.offers).forEach(([index, offer]) => {
            this.$set(this.collapsedOffers, index, offer.start_collapsed);
        });
    },
    methods: {
        isVisible(index) {
            return !this.collapsedOffers[index];
        },
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/_variables";
.our-services-offers-switch {
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    .selection-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        .icon-wrapper {
            display: flex;
            align-items: center;
        }
        input[type="radio"] {
            accent-color: $primary-color;
            border: 1px solid $primary-color-dark;
            height: 20px;
            width: 20px;
            margin-left: 20px;
            margin-right: 20px;
        }

        .switch {
            display: inline-block;
            height: 15px;
            position: relative;
            width: 30px;
            margin-left: 10px;
            margin-right: 10px;

            input {
                display: none;

                &:checked + .slider {
                    background-color: $primary-color;

                    &:before {
                        transform: translateX(10%);
                    }
                }
            }

            .slider {
                background-color: #ccc;
                border-radius: 50px;
                bottom: 0;
                cursor: pointer;
                left: 0;
                position: absolute;
                right: 0;
                top: 0;
                transition: 0.4s;

                &:before {
                    background-color: #fff;
                    border-radius: 50%;
                    bottom: 1px;
                    content: "";
                    height: 13px;
                    position: absolute;
                    transition: 0.4s;
                    transform: translateX(-105%);
                    width: 13px;
                }
            }
        }
    }
}
.our-services-offers-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    
    .offer-card-wrapper {
        max-width: 320px;
        margin: 30px auto 0 auto;
        line-height: 1.1;

        @media (max-width: 1024px) {
            max-width: none;
            flex-basis: 100%;
        }
        &:first-child {
            @media (max-width: 1024px) {
                margin-top: 0;
            }
        }

        .offer-card {
            display: flex;
            flex-direction: column;
            align-items: center;

            min-width: 316px;
    
            padding-bottom: 10px;
    
            border: 2px solid #00a07f;
            border-radius: 5px 5px 15px 15px;
    
            .offer-header-container {
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;

                background-color: #00a07f;
                border-radius: 0 0 4px 4px;

                width: 100%;
                height: 110px;

                .premium-banner-container {
                    position: relative;
                    width: 0;
                    height: 0;
                    left: 35px;

                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .premium-banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        position: absolute;
                        transform: rotate(-45deg);

                        height: 25px;
                        width: 200px;

                        background-color: white;

                        .banner-title {
                            color: #00a07f;
                            font-size: 11px;
                            font-weight: bold;
                            margin-left: 25px;
                        }
                    }
                }

                .offer-header {
                    position: relative;
                    color: white;
                    font-weight: bold;
                    margin: auto;
                }

                .collapse-button {
                    display: flex;
                    justify-content: center;
                    align-content: center;

                    width: 40px;
                    height: 40px;
                    background-color: white;
                    border-radius: 50%;

                    position: absolute;
                    right: 35px;

                    transition: transform .35s;

                    .arrow-down-icon {
                        font-size: 40px;
                        margin: auto;
                    }
                }
                
                .rotate-open {
                    transform: rotate(0deg);
                }
                .rotate-close {
                    transform: rotate(180deg);
                }

            }
    
            .offer-pricing {
                text-align: center;
                font-weight: bold;
                color: #00a07f;
            }
            
            .collapsible-details {
                display: flex;
                overflow: hidden;
                transition: max-height 0.5s;
            }

            .collapse-open {
                max-height: 700px;

                &.free {
                    max-height: 280px;
                }
            }

            .collapse-close {
                max-height: 0;
            }
    
            .offer-details-container {
                display: flex;
                flex-direction: column;
    
                padding: 0 18px;
    
                text-align: left;
    
                .plane-icon {
                    max-width: 20px;
                    transform: rotate(20deg);
                }
                
                td {
                    vertical-align: top;
                    padding: 5px 0 20px 0;
                }
    
                td:first-child {
                    padding-right: 10px;
                }
            }
    
            .offer-button {
                background-color: #ea5354 !important;
                width: 90%;
                @media (max-width: 1024px) {
                    max-width: 270px;
                }
            }
        }
    }

    .card-footnote {
        padding: 0 10px;

        text-align: left;
        font-size: 8px;
        line-height: 1.3;
        color: #00a07f;
        font-style: italic;
        font-weight: 500;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/OffersCards.vue